import { useMutation, useQueryClient } from "react-query";

import { crearEquipo, updateEquipo, deleteEquipo} from '../../services/Equipos';

import { toast } from 'react-hot-toast';
const queryKey = "equipos";

export const useEquiposMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addEquipo = useMutation((body) => crearEquipo(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updateEquipoC = useMutation(
    (body) => updateEquipo( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeEquipo = useMutation((id) => deleteEquipo( id), {
    onSuccess,
    onError,
  });

  return { addEquipo, updateEquipoC, removeEquipo };
};
export default useEquiposMutations;